import React from 'react';
import { TaxExemption as TaxExemptionType } from '~/adapters/services/accounts/tax-exemptions/types';
import { TaxExemptionCertificate } from '~/pages/Settings/tabs/TaxExemption/components/Certificate/TaxExemptionCertificate';

export interface TaxExemptionCertificatesProps {
    taxExemptions: TaxExemptionType[];
}

export const TaxExemptionCertificateList: React.FC<TaxExemptionCertificatesProps> = ({ taxExemptions }) => {
    return (
        <>
            {taxExemptions.map((taxExemption) => {
                return <TaxExemptionCertificate taxExemption={taxExemption} key={taxExemption.id} />;
            })}
        </>
    );
};
